module.exports = __webpack_public_path__ + "static/media/email.b2fbf9a5.png";